import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { SalesTransactionsRoutes } from '../../../routes';

export const SalesTransactionsLayout = () => <SwitchRoute routes={SalesTransactionsRoutes} />;
